<template>
  <div class="row p-2" @click="checkItem">
    <div class="custom-control custom-checkbox mar-l-15">
      <input type="checkbox" class="custom-control-input mar-l-15" :checked="Show" />
      <label class="custom-control-label">{{title}}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: undefined,
    show: {
      default: false,
    },
  },
  methods: {
    checkItem() {
      this.$emit('checkItem', this.title, !this.show);
    },
  },
  computed: {
    Show() {
      return this.show;
    },
  },
};
</script>
<style>
.mar-l-15 {
  margin-left: 15px;
}
</style>
